<template>
    <div class='bar-container'>
        <div class='bar' :style="barStyle" />
        <span class='text'>{{ text }}</span> 
        <span class='votes'>{{ votesString }}</span> 
    </div>
</template>

<script>
export default {
    name: 'result-item',
    props: {
        text: {type: String, required: true},
        value: {type: Number, required: true},
        total: {type: Number, required: true},
        max: {type: Number, required: true},
        animate: {type: Boolean, required: true}
    },

    data(){
        return {
            width: 0,
            votesString: `${this.value} ${this.value == 1 ? "vote" : "votes"}`
        }
    },

    computed: {
        barStyle() {
            return {width: this.width + "%"}
        }
    },

    watch: {
        animate() {
            if(this.animate)
                this.width = Math.min((this.value / this.max) * 100, 90);
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../../assets/style-colors";

    $bar-height: 32px;
    $border-radius: 16px;

    .bar-container {
        position: relative;
        height: $bar-height; 
        background-color: $color-grey; 
        border-radius: $border-radius;
        margin-bottom: 8px;

        .bar {
            z-index: 1;
            position: absolute; 
            background-color:#99badd; 
            height: 100%; 
            left: 0; 
            top: 0; 
            border-radius: $border-radius; 
            line-height: $bar-height;
            font-size: 10px;
            letter-spacing: -0.4px;
            transition: width 0.3s ease-in;
        }

        SPAN.text {position: relative; z-index: 2; float: left; padding-left: 16px; font-size: 12px; line-height: $bar-height; font-weight: 700}
        SPAN.votes {position: relative; z-index: 2; float: right; padding-right: 10px; font-size: 10px; line-height: $bar-height }
    }
    .row {margin-bottom: 5px}
</style>